import moment from 'moment';

export default {
	status: [
		{ title: 'all', propValue: '-1', propKey: 'rateAll', text: 'n/d' },
		{
			title: '9-10 <span class="app-icon icon-star-empty text-primary text-secondary" />',
			propValue: '9-10',
			propKey: 'rate5',
			icon: 'rate5',
			text: 'n/d',
		},
		{
			title: '7-8 <span class="app-icon icon-star-empty text-primary text-secondary" />',
			propValue: '7-8',
			propKey: 'rate4',
			icon: 'rate4',
			text: 'n/d',
		},
		{
			title: '5-6 <span class="app-icon icon-star-empty text-primary text-secondary" />',
			propValue: '5-6',
			propKey: 'rate3',
			icon: 'rate3',
			text: 'n/d',
		},
		{
			title: '3-4 <span class="app-icon icon-star-empty text-primary text-secondary" />',
			propValue: '3-4',
			propKey: 'rate2',
			icon: 'rate2',
			text: 'n/d',
		},
		{
			title: '1-2 <span class="app-icon icon-star-empty text-primary text-secondary" />',
			propValue: '1-2',
			propKey: 'rate1',
			icon: 'rate1',
			text: 'n/d',
		},
	],
	columns: [
		{ isSortable: true, key: 'orderID', label: 'orderId', keyProp: 'order.orderID' },
		{ isSortable: true, key: 'orderTotal', label: 'orderTotal', keyProp: 'order.total' },
		{ isSortable: true, key: 'restaurantName', label: 'restaurant' },
		{ isSortable: true, key: 'comment', label: 'comment', class: 'w-1/2' },
		{ isSortable: true, key: 'count', label: 'stars' },
		{ isSortable: false, key: 'phone', label: 'customer' },
		{ isSortable: true, key: 'registrationtime', label: 'time', initialSort: true, initialSortDirection: 'desc' },
	],
	listColumns: [
		{ isSortable: true, key: 'restaurantname', label: 'restaurant' },
		{ isSortable: true, key: 'comment', label: 'comment', class: 'w-1/2' },
		{ isSortable: true, key: 'count', label: 'stars' },
		{ isSortable: false, key: 'phone', label: 'customer' },
		{ isSortable: true, key: 'registrationtime', label: 'time', initialSort: true, initialSortDirection: 'desc' },
	],
	defaultFilters: {
		ratesNo: -1,
		status: '',
		limit: 50,
		offset: 0,
		startDate: moment()
			.subtract(90, 'day')
			.format('YYYY-MM-DD'),
		endDate: moment()
			.add(1, 'day')
			.format('YYYY-MM-DD'),
		userSearch: '',
	},
};
